import { render } from "./CriarModerador.vue?vue&type=template&id=4bc23263&scoped=true"
import script from "./CriarModerador.vue?vue&type=script&lang=js"
export * from "./CriarModerador.vue?vue&type=script&lang=js"

import "./CriarModerador.vue?vue&type=style&index=0&id=4bc23263&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc23263"]])

export default __exports__